import { Controller } from "@hotwired/stimulus"

export default class FlashController extends Controller {
  connect() {    
    const message = this.element.dataset.flashMessage
    const type = this.element.dataset.flashType || "success"

    if (!message) return

    Swal.fire({
      customClass: {
        popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      html: message,
      icon: type,
      showCloseButton: true,
      buttonsStyling: false,
      showConfirmButton: false,
      timer: 3000
    }).then(() => {
      this.element.remove()
    })
  }
}